import { render } from "./ManualFieldsSetup.vue?vue&type=template&id=4e5be4a8&scoped=true"
import script from "./ManualFieldsSetup.vue?vue&type=script&lang=js"
export * from "./ManualFieldsSetup.vue?vue&type=script&lang=js"

import "./ManualFieldsSetup.vue?vue&type=style&index=0&id=4e5be4a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e5be4a8"]])

export default __exports__